import { FC } from 'react';

import { useDraggable } from '@dnd-kit/core';

import { hostDragId } from '../../dragIds';
import { Host } from '../Host';
import { IDraggableItemProps } from './interfaces';

const DraggableItem: FC<IDraggableItemProps> = ({
  id,
  disabled,
  onHostClick,
  selectedHostsIds,
  onContextMenu,
  onHostDoubleClick,
  openBooking,
  canOpenTooltip,
  setClientUUID,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  isSelecting,
  setSelectedItems,
}) => {
  const { isDragging, setNodeRef, listeners, node } = useDraggable({
    id: hostDragId(Number(id)),
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      onClick={() =>
        queueMicrotask(() =>
          node.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          })
        )
      }
      onContextMenu={() =>
        queueMicrotask(() =>
          node.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          })
        )
      }
      style={{
        opacity: isDragging ? 0 : 1,
        cursor: disabled ? 'pointer' : 'grab',
      }}
    >
      <Host
        id={Number(id)}
        selected={selectedHostsIds.includes(Number(id))}
        onContextMenu={onContextMenu}
        onHostClick={onHostClick}
        onHostDoubleClick={onHostDoubleClick}
        openBooking={openBooking}
        canOpenTooltip={canOpenTooltip}
        setClientUUID={setClientUUID}
        isSelecting={isSelecting}
        setSelectedItems={setSelectedItems}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      />
    </div>
  );
};

export default DraggableItem;
